/**
 * Created by Petr Kubišta on 02.01.2017.
 */

(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.Mobile = Lfl.Mobile || {};

    (function (Mobile, $, undefined) {

        /**
         * Directs calls to native mobile code
         * @memberOf Lfl.Mobile
         */
        Lfl.Mobile.Sender = Mobile.Sender || {};

        (function (Sender, $, undefined) {

            if (MobileCallbacks.mobilePlatform() === "apple") {
                Sender.onAjaxSuccess = function (result) {
                    webkit.messageHandlers.onAjaxSuccess.postMessage({
                        "result": result
                    });
                };

                Sender.onAjaxFailure = function (taskId, x, errorText, y) {
                    webkit.messageHandlers.onAjaxFailure.postMessage({
                        "taskId": taskId,
                        "x": x,
                        "errorText": errorText,
                        "y": y
                    });
                };

                Sender.onUserReturned = function (result) {
                    webkit.messageHandlers.onUserReturned.postMessage({
                        "result": result
                    });
                };

                Sender.showSettings = function () {
                    webkit.messageHandlers.showSettings.postMessage(null);
                };

                Sender.onMessageCountUpdated = function (count) {
                    webkit.messageHandlers.onMessageCountUpdated.postMessage({
                        "count": count
                    });
                };

                Sender.tokenRegistered = function (success) {
                    webkit.messageHandlers.tokenRegistered.postMessage({
                        "success": success
                    });
                };

                Sender.onModalOpen = function () {
                    webkit.messageHandlers.onModalOpen.postMessage(null);
                };

                Sender.onModalClosed = function () {
                    webkit.messageHandlers.onModalClosed.postMessage(null);
                };

                Sender.onPhotoswipeOpen = function () {
                    webkit.messageHandlers.onPhotoswipeOpen.postMessage(null);
                };

                Sender.onPhotoswipeClosed = function () {
                    webkit.messageHandlers.onPhotoswipeClosed.postMessage(null);
                };

                Sender.onPhotoswipeFocus = function (focus) {
                    webkit.messageHandlers.onPhotoswipeFocus.postMessage({
                        "focus": focus
                    });
                }

                Sender.modalClosePassed = function () {
                    webkit.messageHandlers.modalClosePassed.postMessage(null);
                };

                Sender.onLoggedIn = function () {
                    webkit.messageHandlers.onLoggedIn.postMessage(null);
                };

                Sender.saveUsername = function (username) {
                    webkit.messageHandlers.saveUsername.postMessage({
                        "username": username
                    });
                };

                Sender.setInstallationUrl = function (installationUrl) {
                    webkit.messageHandlers.setInstallationUrl.postMessage({
                        "installationUrl" : installationUrl
                    });
                };

                Sender.resetInstallationUrl = function () {
                    webkit.messageHandlers.resetInstallationUrl.postMessage(null);
                };

                Sender.setBadgeCount = function (badgeCount) {
                    webkit.messageHandlers.setBadge.postMessage({
                        "count" : badgeCount
                    });
                };

                // Note: Those methods request the application to call a callback to provide the value.
                //       TODO Refactor - consider passing in the name of the callback function, for better decoupling.
                Sender.requestCurrentInstallationUrl = function (promiseId) {
                    webkit.messageHandlers.requestCurrentInstallationUrl.postMessage({
                        "promiseId" : promiseId
                    });
                };

                Sender.requestHasUsedCurrentInstallation = function (promiseId) {
                    webkit.messageHandlers.requestHasUsedCurrentInstallation.postMessage({
                        "promiseId" : promiseId
                    });
                };

                Sender.getMobileNotificationsIssuesInfoPageDisplayedTimestamp = function () {
                    return -1;
                };

                Sender.setMobileNotificationsIssuesInfoPageDisplayedTimestamp = function (timestamp) {
                };

                Sender.wasMobileNotificationsIssuesInfoPageResolved = function () {
                    return true;
                };

                Sender.setMobileNotificationsIssuesInfoPageResolved = function () {
                };
            }
        }(Mobile.Sender = Mobile.Sender || {}, jQuery));
    }(Lfl.Mobile = Lfl.Mobile || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
